module.exports = __webpack_public_path__ + "img/组 17.bc633eba.png";